/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const productGrid = {
  productGrid: {
    length: 'Comprimento (mm)',
    packetWeight: 'Peso do balote (kg)',
    sheetsWeight: "Balote de aprox.",
    sheetsByPackage: "Chapas / Balote",
    quantity: 'Número de balotes',
    quantityLabel: 'Informe a quantidade de BALOTES desejada',
    outOfStock: 'Sem stock',

    error:{
      minimumWeight: 'Peso mínimo {{minWeight}} Kg',
      maximumWeight: 'Peso máximo {{maxWeight}} Kg',
      quantity: 'Por favor, introduza uma quantidade válida',
      length: 'Por favor, introduza um comprimento válido',
    }
  },

};
